/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import OktaAuth from '@okta/okta-auth-js';
import { OktaAuthModule } from '@okta/okta-angular';
import { environment } from '../environments/environment.dev'; 
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    provideMarkdown(),
    importProvidersFrom(
      OktaAuthModule.forRoot({
        oktaAuth: new OktaAuth({
          issuer: environment.issuer,
          clientId: environment.clientId,
          redirectUri: environment.redirectUri,
          scopes: environment.scopes,
        }
        ),
      })
    )
  ]
};
